import { SETTINGS_SMART_NOTIFICATIONS } from '~/app_constants';

const presetAttributes = (preset) => {
  const attributes = { ...preset, deliver_by: Object.keys(preset.deliver_by).filter((key) => preset.deliver_by[key]) };

  if (attributes.name === SETTINGS_SMART_NOTIFICATIONS.presets.high_activity.label) {
    attributes.condition_value = 95;
    attributes.recipients = { roles: ['owner', 'manager', 'team_lead'], members: [] };
  }

  if (attributes.name === SETTINGS_SMART_NOTIFICATIONS.presets.low_activity.label) {
    attributes.condition_value = 20;
    attributes.frequency = 'daily';
    attributes.recipients = { roles: ['owner', 'manager', 'team_lead'], members: [] };
  }

  if (preset.condition_value.includes(':')) {
    const [hours, minutes] = preset.condition_value.split(':');

    attributes.condition_value = Number(hours) * 3600 + Number(minutes) * 60;
  }

  if (['time_spent_in_app', 'time_spent_in_url'].includes(attributes.metric_type)) {
    attributes.tool_type = attributes.metric_type === 'time_spent_in_app' ? 'application' : 'url';
    attributes.metric_type = 'time_spent_in_tool';
    attributes.tool_names = attributes.tools.names;
  }

  if (!SETTINGS_SMART_NOTIFICATIONS.options.timeBasedMetrics.includes(preset.metric_type)) {
    attributes.time_unit = null;
  }

  return attributes;
};

export const buildNotificationParams = (presetKey) => ({
  ...SETTINGS_SMART_NOTIFICATIONS.defaultFormSetting,
  target: { members: ['all'] },
  recipients: { roles: ['owner', 'manager'] },
  ...presetAttributes(SETTINGS_SMART_NOTIFICATIONS.presets[presetKey]),
});
